import React, { useState } from 'react'
import {
  Button,
  Field,
  Control,
  Input,
  Columns,
  Column,
  Notification,
  Delete,
  Icon,
  Select,
  TextArea,
} from 'bloomer'
import { useHistory } from 'react-router-dom'
import { CenteredForm } from '../utils/centered-form'

export function BikeForm(props: { bike: BikeFields; onSave: (bike: BikeFields) => Promise<void> }) {
  const [errorMessage, setErrorMessage] = useState('')
  const [bike, setBike] = useState(props.bike)
  const history = useHistory()

  return (
    <CenteredForm
      onSubmit={async (e) => {
        e.preventDefault()
        try {
          await props.onSave({ createdAt: new Date(), ...bike, updatedAt: new Date() })
          history.push('/riders')
        } catch (error) {
          setErrorMessage(error.message)
        }
      }}
    >
      {errorMessage && (
        <Notification isColor="danger">
          <Delete onClick={() => setErrorMessage('')} />
          {errorMessage}
        </Notification>
      )}

      <Field>
        <Control hasIcons="left">
          <Icon className="fas fa-motorcycle"></Icon>
          <Input
            value={bike.name}
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              setBike({ ...bike, name: event.currentTarget.value })
            }
            autoComplete="off"
            placeholder="Name"
            autoFocus
          />
        </Control>
      </Field>

      <Field>
        <Control hasIcons="left">
          <Icon className="fas fa-heartbeat"></Icon>
          <Select
            isFullWidth
            value={bike.engine}
            onChange={(e: React.FormEvent<HTMLSelectElement>) =>
              setBike({ ...bike, engine: e.currentTarget.value as '2-stroke' | '4-stroke' })
            }
          >
            <option value="2-stroke">2-stroke</option>
            <option value="4-stroke">4-stroke</option>
          </Select>
        </Control>
      </Field>

      <Field>
        <Control>
          <TextArea
            value={bike.notes}
            onChange={(event: React.FormEvent<HTMLInputElement>) =>
              setBike({ ...bike, notes: event.currentTarget.value })
            }
            placeholder="Notes"
          />
        </Control>
      </Field>

      <Field>
        <Columns>
          <Column>
            <Control>
              <Button isFullWidth onClick={() => history.push('/riders')}>
                Cancel
              </Button>
            </Control>
          </Column>
          <Column>
            <Control>
              <Button isColor="primary" isFullWidth type="submit">
                Save Bike
              </Button>
            </Control>
          </Column>
        </Columns>
      </Field>
    </CenteredForm>
  )
}

interface BikeFields {
  name: string
  engine: '2-stroke' | '4-stroke'
  notes: string
  createdAt?: Date
  updatedAt?: Date
}
